<form [formGroup]="versionUpdateForm" class="create-instance-form">
    <div class="flex flex-col updateForm">
        <div class="flex-col form-field">
            <div class="flex-row mb-4">
                <div class="h-48">
                    <h2 class="fs-24 fw-700 m-0">{{ title }}</h2>
                    <mat-icon svgIcon="close" class="close-icon w-32 h-32" (click)="sidenavService.closeRightSidenav()">
                    </mat-icon>
                </div>
                <hr class="separator" />
                <label class="fs-12 fw-700 instance-label-align">
                    {{ 'RUNBOOK.RUNBOOK_NAME' | transloco | uppercase }}
                </label>
                <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right"
                    [matTooltip]="'RUNBOOK.RUNBOOK_NAME' | transloco"
                    matTooltipPosition="{{ Constants.POSITION_RIGHT }}">
                </mat-icon>
            </div>

            <p class="flex items-center rounded px-4 py-3 m-0 disabled-input">
                {{ name || '-' }}
            </p>
        </div>
        <div class="flex-col form-field">
            <div class="flex-row mb-4">
                <label class="fs-12 fw-700 instance-label-align">
                    {{ 'RUNBOOK.COMPONENT_TYPE' | transloco | uppercase }}
                </label>
                <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right"
                    [matTooltip]="'RUNBOOK.COMPONENT_TYPE' | transloco"
                    matTooltipPosition="{{ Constants.POSITION_RIGHT }}">
                </mat-icon>
            </div>

            <p class="flex items-center rounded px-4 py-3 m-0 disabled-input">
                {{ componentType || '-' }}
            </p>
        </div>
        <div class="flex-col form-field">
            <div class="flex-row mb-4">
                <label class="fs-12 fw-700 instance-label-align">
                    {{ 'RUNBOOK.CURRENT_VERSION' | transloco | uppercase }}
                </label>
                <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right"
                    [matTooltip]="'RUNBOOK.CURRENT_VERSION' | transloco"
                    matTooltipPosition="{{ Constants.POSITION_RIGHT }}">
                </mat-icon>
            </div>

            <p class="flex items-center rounded px-4 py-3 m-0 disabled-input">
                {{ currentVersion || '-' }}
            </p>
        </div>
        <div class="flex-col form-field">
            <div class="flex-row mb-4">
                <label class="fs-12 fw-700 instance-label-align">
                    {{ 'RUNBOOK.CHOOSE_VERSION' | transloco | uppercase }}
                </label>
                <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right"
                    [matTooltip]="'RUNBOOK.CHOOSE_VERSION' | transloco"
                    matTooltipPosition="{{ Constants.POSITION_RIGHT }}">
                </mat-icon>
            </div>

            <select class="form-select" formControlName="version">
                <option value="" disabled hidden selected>{{'RUNBOOK.CHOOSE_VERSION'| transloco}}</option>
                <option *ngIf="!componentsLoading && versions?.length === 0" disabled>{{'RUNBOOK.NO_VERSION_FOUND' | transloco}}</option>
                <option *ngFor="let v of versions" [value]="v.version">
                    {{ v.version }}
                </option>
            </select>
            <app-error [control]="versionUpdateForm.get('version')"></app-error>
        </div>

    </div>
</form>

<span class="flex-auto"></span>
<mat-divider class="neutral-2 mb-20"></mat-divider>

<div class="pt-4 pb-16">
    <div class="flex flex-row justify-end gap-x-6">
        <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">
            {{ 'BUTTONS.CANCEL' | transloco }}
        </button>
        <button class="accent" type="button" (click)="confirmSubmit()">
            {{ 'BUTTONS.CONFIRM' | transloco }}
        </button>
    </div>
</div>